import { Component, EventEmitter, Input, OnInit, Output, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormControl, FormGroup, FormsModule, NgForm, ReactiveFormsModule, Validators} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { Perfil } from '../../../core/models/AuthModel';
import { PerfilService } from '../../../features/perfil/services/perfil-config-service';
import { UsuarioService } from '../../../features/user/services/user-service';
import { Usuario } from '../../../features/user/models/usuario';
import {InputCustom} from "../input-custom/input-custom";
import {CustomButtonComponent} from '../custom-button/custom-button';
import {ToastService} from '../../../core/services/toast/toast-service';


@Component({
  selector: 'app-usuario-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    InputCustom,
    ReactiveFormsModule,
    CustomButtonComponent
  ],
  templateUrl: './usuario-modal.component.html',
  styleUrls: ['./usuario-modal.component.scss']
})
export class UsuarioModalComponent implements OnInit, OnChanges {

  @Input() isOpen: boolean = false;
  @Input() usuario: Usuario = {} as Usuario;
  @Input() heading: string = '';
  @Input() button: string = '';
  @Input() classButton: string = 'bg-blue-600 hover:bg-blue-700';
  @Output() usuarioSaved = new EventEmitter<Usuario>();
  @Output() modalClosed = new EventEmitter<void>();

  // Propiedades del componente
  validarUsuario: boolean = false;
  public fieldTextType: boolean = false;
  public fieldTextTypeCFM: boolean = false;
  public perfiles: Perfil[] = [];
  cfnPass: String = "";
  errCfnPass: Boolean = false;
  submitted = false;
  edit: boolean = false;
  constructor(
    private perfilService: PerfilService,
    private usuarioService: UsuarioService,
    private toastService:  ToastService
  ) { }

  usuarioForm = new FormGroup({
    username: new FormControl('', [Validators.required, Validators.maxLength(60)]),
    nombre: new FormControl('', [Validators.required, Validators.maxLength(60)]),
    apellido : new FormControl('', [Validators.required, Validators.maxLength(60)]),
    email: new FormControl('', [Validators.required, Validators.email, Validators.maxLength(80)]),
    perfil: new FormControl<Perfil[]>([], [Validators.required])
  });

  ngOnInit() {
    this.edit = !!this.usuario.id;
    this.loadPerfiles();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['usuario'] && this.usuario && this.usuario.id) {
      this.loadFormData();
    }

    if (changes['isOpen'] && this.isOpen) {
      if (this.usuario && this.usuario.id) {
        this.loadFormData();
      } else {
        this.resetForm();
      }
    }
  }

  private loadPerfiles() {
    this.perfilService.findAll().subscribe(
      res => {
        this.perfiles = res;
        // Si ya tenemos usuario, cargar los datos después de obtener los perfiles
        if (this.usuario && this.usuario.id) {
          this.loadFormData();
        }
      },
      error => console.error('Error al cargar perfiles:', error)
    );
  }

  private loadFormData() {
    if (this.usuario && this.usuario.id) {
      this.usuarioForm.patchValue({
        username: this.usuario.username || '',
        nombre: this.usuario.nombre || '',
        apellido: this.usuario.apellido || '',
        email: this.usuario.email || '',
        perfil: this.usuario.perfil || []
      });
    }
  }

  onSave(): void {
    this.submitted = true;

    this.usuarioForm.markAllAsTouched();

    if (this.usuarioForm.invalid) {
      return;
    }

    this.usuario.username = this.usuarioForm.get('username')?.value || '';
    this.usuario.nombre = this.usuarioForm.get('nombre')?.value || '';
    this.usuario.apellido = this.usuarioForm.get('apellido')?.value || '';
    this.usuario.email = this.usuarioForm.get('email')?.value || '';
    this.usuario.perfil = this.usuarioForm.get('perfil')?.value || [];

    if (!this.usuario.id) {
      this.usuarioService.findByUsuario(this.usuario.username).subscribe({
        next: (res) => {
          if (res) {
            // Muestra el toast y no cierra el modal si el usuario existe
            this.toastService.showToast('El usuario ya existe.', 'error');
          } else {
            this.validarUsuario = false;
            this.usuarioSaved.emit(this.usuario);
            this.onClose();
          }
        },
        error: (error) => {
          console.error('Error al validar usuario:', error);
        }
      });
    } else {
      this.usuarioSaved.emit(this.usuario);
      this.onClose();
    }
  }

  onClose(): void {
    this.resetForm();
    this.modalClosed.emit();
  }

  private resetForm(): void {
    this.submitted = false;
    this.validarUsuario = false;
    this.errCfnPass = false;
    this.cfnPass = "";
    this.fieldTextType = false;
    this.fieldTextTypeCFM = false;

    this.usuarioForm.reset();

  }

  getPerfil($event: any) {

  }

  comparaPerfil(perfil1: Perfil, perfil2: Perfil) {
    return perfil1 && perfil2 ? perfil1.id === perfil2.id : perfil1 === perfil2;
  }

  get username() {
    return this.usuarioForm.get('username');
  }

  get nombre() {
    return this.usuarioForm.get('nombre');
  }

  get apellido() {
    return this.usuarioForm.get('apellido');
  }
  get email() {
    return this.usuarioForm.get('email');
  }
  get perfilControl() {
    return this.usuarioForm.get('perfil') as FormControl<Perfil[]>;
  }
}
